export const FETCH_EXCEL_REQUEST="FETCH_EXCEL_REQUEST"
export const FETCH_EXCEL_SUCCESS="FETCH_EXCEL_SUCCESS"
export const FETCH_EXCEL_FAIL="FETCH_EXCEL_FAIL"